import { useEffect, useRef } from "react";
import useViewsSelector from "views/stores/useViewsSelector";
import { selectSearchJobId } from "views/logic/slices/searchExecutionSelectors";
const useOnSearchExecution = (fn) => {
  const searchResultId = useViewsSelector(selectSearchJobId);
  const lastSearchResultId = useRef();
  useEffect(() => {
    if (lastSearchResultId.current !== searchResultId) {
      fn();
    }
    lastSearchResultId.current = searchResultId;
  }, [searchResultId]);
};
export default useOnSearchExecution;
